<template>
  <div class="banner">
    <div class="banner-wrapper">
      <div class="banner-img">
        <img src="../../../assets/images/banner/banner-shop.jpg" alt="" />
      </div>
      <div class="shopMain">
        <div class="shopImgBox">
          <!-- <img class="shopImg" :src="shopList[0].imageUrls?shopList[0].imageUrls[0]:''" alt="" /> -->
          <div class="lgImgBox">
            <img class="shopImg" :src="lgImg" alt="" />
          </div>
          <div class="skuImgBox">
            <img class="skuImg" v-for="item in shopList" :key="item.id" :src="item.imageUrls.length>0?item.imageUrls[0]:''" @click="clickImg(item)" alt="" />
          </div>
        </div>
        <div class="shopInfo" v-if="skuObj.skuCode">
            <div class="infoTitle">{{spuObj.name}}</div>
            <ul class="skuList">
              <li>sku编码：{{skuObj.skuCode}}</li>
              <li>价格：{{skuObj.price}}</li>
              <li>库存数量：{{skuObj.stock}}</li>
              <li>规格参数：{{skuObj.specifications}}{{skuObj.unit||''}}</li>
              <li>商品条形码：{{skuObj.barcode}}</li>
              <li>是否上架：{{skuObj.status==1?"上架":"下架"}}</li>
              <li>商品品牌：{{skuObj.brand}}</li>
              <li>储存条件：{{skuObj.storageConditions}}</li>
              <li>食品生产许可证编号：{{skuObj.foodLicenseNo}}</li>
              <li>商品净含量：{{skuObj.netWeight}}</li>
              <li>品质认证信息：{{skuObj.qualityCertification}}</li>
              <li>有机食品认证编号：{{skuObj.organicCertNo}}</li>
              <li>是否转基因：{{skuObj.isGmo?"是":"否"}}</li>
              <li>产地：{{skuObj.origin}}</li>
              <li>售卖方式：{{skuObj.sellingMethod}}</li>
              <li>是否为有机食品：{{skuObj.isOrganic?"是":"否"}}</li>
              <li>商品保质期：{{skuObj.shelfLife}}</li>
              <li>生产企业名称：{{skuObj.manufacturer}}</li>
              <li>包装方式：{{skuObj.packageType}}</li>
              <li>套餐分量：{{skuObj.portion}}</li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { Loading } from "element-ui";
export default {
  name: "ShopInfo",
  data() {
    return {
      spuObj: {},
      shopList: [],
      skuObj:{},
      lgImg:'',
    };
  },
  created() {
    this.spuObj = this.$route.params.rowData;
    this.getSkuList()
  },
  methods: {
    getSkuList(){
      let that = this
      axios
        .get(`http://121.40.212.122:8091/product/sku/listBySpu/${that.spuObj.id}`)
        // .get(`http://localhost:8091/product/sku/listBySpu/${that.spuObj.id}`)
        .then((response) => {
          // 创建独立的数组副本
          that.shopList = [...response.data.data];
          if (that.shopList&&that.shopList.length>0) {
            that.skuObj = that.shopList[0]
            if(that.shopList[0].imageUrls&&that.shopList[0].imageUrls.length>0)
            that.lgImg = that.shopList[0].imageUrls[0]
          }
        });
    },
    clickImg(row){
      this.lgImg = row.imageUrls[0]
      this.skuObj = row
    }
  },
};
</script>
<style scoped>
.banner-img {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 180px;
  margin-bottom: 22px;
}
.banner-img img {
  width: 100%;
  height: 600px;
  backdrop-filter: color(100% 100%);
}
.shopMain {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.shopImgBox{
  width: 640px;
    height: 800px;
    padding-top: 16px;
    border: solid 1px #ccc;
    border-radius: 15px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.lgImgBox{
  width: 600px;
  height: 600px;
}
.shopImg {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.skuImgBox{
  width: 600px;
  height: 200px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.skuImg{
  width: 148px;
  height: 150px;
  margin-right: 2px;
  border: solid 1px #ccc;
  object-fit: contain;
}
.infoTitle {
  font-size: 30px;
  color: rgb(0, 102, 203);
  font-weight: bold;
  padding: 20px;
}
.skuList {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  list-style: none;
  padding: 0;
  margin: 0;
}

.skuList li {
  list-style: none;
  flex: 0 0 50%; /* 每个li占50%宽度 */
  box-sizing: border-box;
  padding: 20px;
  border-bottom: 1px solid #eee; /* 可选的分隔线 */
}
</style>



// WEBPACK FOOTER //
// src/components/children/ShopView/ShopInfo.vue